import { XMarkIcon } from '@heroicons/react/16/solid';
import { MediaType } from '../../../../Chat.enum.ts';
import { useChatContext } from '../../../../Chat.hook.ts';
import './ReplyAction.styles.scss';

export function ReplyAction() {
  const { replyMessage, setReplyMessage } = useChatContext();

  function messageType() {
    if (
      replyMessage?.content?.attachments &&
      replyMessage.content.attachments.length === 0
    ) {
      return 'Archivo';
    }

    const mediaType = replyMessage?.content?.attachments?.[0]?.mediaType;
    switch (mediaType) {
      case MediaType.IMAGE:
        return 'Imagen';
      case MediaType.VIDEO:
        return 'Video';
      case MediaType.AUDIO:
        return 'Audio';
      case MediaType.STICKER:
        return 'Sticker';
      default:
        return 'Archivo';
    }
  }

  return (
    <div className="ReplyAction">
      <div className="ReplyAction__Container">
        {replyMessage?.content?.text !== ''
          ? replyMessage?.content?.text
          : messageType()}
      </div>
      <XMarkIcon
        onClick={() => {
          setReplyMessage(null);
        }}
        className="ReplyAction__Icon"
      />
    </div>
  );
}
